<template>
    <div class="wui-container business">
        <div class="type">
            <div class="select" @click="show = true">
                <span class="label">{{ $t("合作类型") }}</span>
                <span class="value">
                    <span v-show="form.cooperation_type === ''">{{ $t("请选择") }}</span>
                    <span v-show="form.cooperation_type === 1">{{ $t("公寓商户") }}</span>
                    <span v-show="form.cooperation_type === 2">{{ $t("优质民宿") }}</span>
                    <span v-show="form.cooperation_type === 3">{{ $t("异业合作") }}</span>
                    <span v-show="form.cooperation_type === 4">{{ $t("广告推广") }}</span>
                    <span v-show="form.cooperation_type === 5">{{ $t("其他") }}</span>
                    <i class="iconfont icon-MoreArrow"></i>
                </span>
            </div>
            <div class="tip" v-if="form.cooperation_type === 1">{{ $t("公寓商户介绍") }}</div>
        </div>

        <div class="form-group">
            <div class="form-item">
                <div class="label">{{ $t("姓名") }}</div>
                <div class="value">
                    <input type="text" v-model="form.name" :placeholder="$t('你的称呼')">
                </div>
            </div>
            <div class="form-item">
                <div class="label">{{ $t("联系方式") }}</div>
                <div class="value">
                    <input type="text" v-model="form.contact_way" :placeholder="$t('手机号微信号')">
                </div>
            </div>
            <div class="form-item">
                <div class="label">{{ $t("公司名称") }}</div>
                <div class="value">
                    <input type="text" v-model="form.company_name" :placeholder="$t('请输入')">
                </div>
            </div>
            <div class="form-item">
                <div class="label">{{ $t("城市") }}</div>
                <div class="value">
                    <input type="text" v-model="form.city" :placeholder="$t('希望开展合作的城市')">
                </div>
            </div>
            <div class="form-item">
                <div class="label">{{ $t("备注") }}<span>{{ $t("选填") }}</span></div>
                <div class="value">
                    <textarea v-model="form.explain" :placeholder="$t('请输入')"></textarea>
                </div>
            </div>
        </div>

        <div class="btn-fixed">
            <div class="btn-primary" @click="submit">{{ $t("提交") }}</div>
        </div>

        <van-overlay :show="show" @click="show = false">
            <div class="dialog" @click.stop>
                <div class="title">{{ $t("合作类型") }}</div>
                <div class="content">
                    <div class="list">
                        <div class="item"
                            :class="{'item-active': form.cooperation_type === 1}"
                            @click="setCooperationType(1)">
                            <span class="name">{{ $t("公寓商户") }}</span>
                            <span class="icon">
                                <i class="iconfont icon-radio"></i>
                                <i class="iconfont icon-checked"></i>
                            </span>
                        </div>
                        <div class="item"
                            :class="{'item-active': form.cooperation_type === 2}"
                            @click="setCooperationType(2)">
                            <span class="name">{{ $t("优质民宿") }}</span>
                            <span class="icon">
                                <i class="iconfont icon-radio"></i>
                                <i class="iconfont icon-checked"></i>
                            </span>
                        </div>
                        <div class="item"
                            :class="{'item-active': form.cooperation_type === 3}"
                            @click="setCooperationType(3)">
                            <span class="name">{{ $t("异业合作") }}</span>
                            <span class="icon">
                                <i class="iconfont icon-radio"></i>
                                <i class="iconfont icon-checked"></i>
                            </span>
                        </div>
                        <div class="item"
                            :class="{'item-active': form.cooperation_type === 4}"
                            @click="setCooperationType(4)">
                            <span class="name">{{ $t("广告推广") }}</span>
                            <span class="icon">
                                <i class="iconfont icon-radio"></i>
                                <i class="iconfont icon-checked"></i>
                            </span>
                        </div>
                        <div class="item"
                            :class="{'item-active': form.cooperation_type === 5}"
                            @click="setCooperationType(5)">
                            <span class="name">{{ $t("其他") }}</span>
                            <span class="icon">
                                <i class="iconfont icon-radio"></i>
                                <i class="iconfont icon-checked"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { Overlay, Toast } from 'vant';
import api from "@/api/index";
import { useRoute } from "vue-router";

export default {
    components: {
        VanOverlay: Overlay
    },
    data() {
        return {
            form: {
                user_id: '',
                name: '',
                cooperation_type: '',
                company_name: '',
                contact_way: '',
                city: '',
                explain: ''
            },
            show: false,
        };
    },
    mounted() {
        const route = useRoute();
        this.form.user_id = route.query.user_id;

        if (route.query.theme == 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
        }
        if (route.query.lang && ['zh', 'en', 'tw'].includes(route.query.lang)) {
            this.$i18n.locale = route.query.lang
        }

        document.title = this.$t('商务合作');
    },
    methods: {
        submit() {
            if (this.form.cooperation_type === '' || this.form.name === '' || this.form.contact_way === '' || this.form.company_name === '' || this.form.city === '') {
                Toast(this.$t('请填写完整信息'));
                return;
            }
            const toast = Toast.loading({
                forbidClick: true,
            });
            api.common.businessCooperation(this.form).then(res => {
                toast.clear();
                if (res.code === 200) {
                    Toast(this.$t('提交成功'));
                    this.form.name = '';
                    this.form.cooperation_type = '';
                    this.form.company_name = '';
                    this.form.contact_way = '';
                    this.form.city = '';
                    this.form.explain = '';
                }
            })
        },
        setCooperationType(type) {
            this.form.cooperation_type = type;
            this.show = false;
        }
    },
};
</script>

<style scoped>
.dialog{
    position: absolute;
    bottom: 60px;
    left: 0;
    right: 0;
    margin: 0 15px;
    background-color: var(--wlc-bg-white);
    /* background-color: var(--wlc-bg-color); */
    border-radius: 10px;
}
.dialog .title{
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 15px;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: var(--wlc-text-color);
}
.dialog .list .item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    padding: 0 15px;
    border-top: 1px solid var(--wlc-border-color);
}
.dialog .list .item .name{
    font-size: 14px;
    font-weight: 400;
    color: var(--wlc-text-color);
}
.dialog .list .item .iconfont{
    font-size: 20px;
}
.dialog .list .item .icon-checked{
    color: var(--wlc-primary-color);
    display: none;
}
.dialog .list .item .icon-radio{
    color: rgba(229, 229, 229, 1);
}
.dialog .list .item-active .icon-checked{
    display: block;
}
.dialog .list .item-active .icon-radio{
    display: none;
}

.btn-fixed{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background-color: var(--wlc-bg-white);
    padding: 15px;
    border-top: 1px solid var(--wlc-border-color);
}
.btn-primary{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-color: var(--wlc-primary-color);
    border-radius: 10px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
}
.btn-primary:active{
    opacity: 0.9;
}

.form-group{
    margin-top: 10px;
    border-radius: 10px;
    background-color: var(--wlc-bg-white);
    padding: 20px;
}
.form-item{
    margin-bottom: 20px;
}
.form-item:last-child{
    margin-bottom: 0;
}
.form-item .label{
    font-size: 15px;
    font-weight: 600;
    line-height: 21px;
    color: var(--wlc-text-color);
    margin-bottom: 10px;
}
.form-item .label span{
    color: rgba(153, 153, 153, 1);
}
.form-item .value{
    border-radius: 10px;
    background-color: var(--wlc-bg-color);
}
.form-item .value input{
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    border: none;
    padding: 0 15px;
    font-size: 15px;
    color: var(--wlc-text-color);
    background-color: transparent;
    overflow: hidden;
}
.form-item .value input::placeholder{
    color: rgba(153, 153, 153, 1);
}
.form-item .value textarea{
    box-sizing: border-box;
    width: 100%;
    height: 100px;
    padding: 15px;
    border: none;
    font-size: 15px;
    color: var(--wlc-text-color);
    background-color: transparent;
}


.business {
    padding: 10px 0 90px 0;
    min-height: auto;
}
.business .type{
    margin-top: 10px;
    padding: 20px;
    border-radius: 10px;
    background-color: var(--wlc-bg-white);
}
.business .select{
    display: flex;
    align-items: center;
    height: 21px;
}
.business .select .label{
    font-size: 15px;
    font-weight: 600;
    color: var(--wlc-text-color);
}
.business .select .value{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    font-size: 15px;
    color: rgba(153, 153, 153, 1);
}
.business .select .value .iconfont{
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
}
.business .tip{
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: rgba(153, 153, 153, 1);
    padding-top: 10px;
    margin-top: 10px;
    border-top: 1px solid var(--wlc-border-color);
}
</style>
